import x from "./../../images/x.png"
import tiktok from "./../../images/tiktok.png"
import instagram from "./../../images/insta.png"
import whatsapp from "./../../images/Group.png"
import linkedin_url from "./../../images/linkedin.svg"
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { getSettings, setShowNav } from "../../features/settingsSlice";
import { useEffect } from "react";

const Header = () => {

    const container = {
        hidden: { opacity: 1, scale: 0 },
        visible: {
            opacity: 1,
            scale: 1,
            transition: {
                delayChildren: 0,
                staggerChildren: 0
            }
        }
    };
    
    const item = {
        hidden: { x: -200, opacity: 0 },
        visible: {
            x: 0,
            opacity: 1,
            transition: {
                type: "spring",
                stiffness: 300,
                damping: 20,
                duration: 0.6,
                delay: 1
            }
        }
    };
    
    const item2 = {
        hidden: { x: 200, opacity: 0 },
        visible: {
            x: 0,
            opacity: 1,
            transition: {
                type: "spring",
                stiffness: 300,
                damping: 20,
                duration: 0.6,
                delay: 1
            }
        }
    };
    const dispatch = useDispatch<AppDispatch>();
    const showNav = useSelector((state: RootState) => state.settings.showNav);
    const settings = useSelector((state: RootState) => state.settings.settings);
    
    useEffect(() => {
        dispatch(getSettings())
        
    }, [dispatch])

    return (
        <header>
            <nav className={showNav ? "open" : ""}>
                <div>
                <div className="links">
                    <Link to={"/"} onClick={() => {dispatch(setShowNav())}}>الصفحه الرئيسيه </Link>
                    <Link to={"/services"} onClick={() => {dispatch(setShowNav())}}>خدماتنا</Link>
                    <Link to={"/portfolio"} onClick={() => {dispatch(setShowNav())}}>أعمالنا</Link>
                    <Link to={"/about-us"} onClick={() => {dispatch(setShowNav())}}>من نحن</Link>
                    <Link to={"/contact-us"} onClick={() => {dispatch(setShowNav())}}>طلب السعر</Link>
                </div>
                <div className="social_link">
                    {
                    settings?.whatsapp_url && (
                        <a href={settings?.whatsapp_url} target="_blank">
                            <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.5021 4.08334C35.7783 4.08334 44.9188 13.2239 44.9188 24.5C44.9188 35.7761 35.7783 44.9167 24.5021 44.9167C20.894 44.9229 17.3493 43.968 14.2326 42.1502L4.09365 44.9167L6.85398 34.7737C5.03477 31.6559 4.07916 28.1097 4.08548 24.5C4.08548 13.2239 13.226 4.08334 24.5021 4.08334ZM17.5441 14.9042L17.1358 14.9205C16.8718 14.9387 16.6139 15.008 16.3763 15.1247C16.1549 15.2503 15.9528 15.407 15.7761 15.5902C15.5311 15.8209 15.3922 16.021 15.2432 16.2149C14.488 17.1968 14.0814 18.4022 14.0876 19.6408C14.0917 20.6413 14.353 21.6151 14.7614 22.5257C15.5964 24.3673 16.9704 26.3171 18.7834 28.124C19.2204 28.5588 19.6491 28.9958 20.1105 29.402C22.3634 31.3853 25.0478 32.8157 27.9505 33.5793L29.1102 33.7569C29.4879 33.7773 29.8656 33.7488 30.2454 33.7304C30.8399 33.699 31.4203 33.5381 31.9461 33.2588C32.2132 33.1206 32.4741 32.9708 32.728 32.8096C32.728 32.8096 32.8145 32.7511 32.9832 32.6258C33.2589 32.4217 33.4283 32.2767 33.657 32.0378C33.8285 31.8609 33.9714 31.6554 34.0857 31.4213C34.245 31.0885 34.4042 30.4535 34.4696 29.9247C34.5186 29.5205 34.5043 29.3 34.4981 29.1632C34.49 28.9447 34.3083 28.7181 34.1102 28.6221L32.922 28.0893C32.922 28.0893 31.1457 27.3155 30.0596 26.8214C29.9459 26.7719 29.8241 26.7435 29.7002 26.7377C29.5605 26.7231 29.4193 26.7386 29.2862 26.7834C29.153 26.8281 29.031 26.901 28.9285 26.997C28.9183 26.9929 28.7815 27.1093 27.3054 28.8978C27.2206 29.0116 27.1039 29.0976 26.9701 29.1449C26.8363 29.1922 26.6915 29.1985 26.554 29.1632C26.421 29.1277 26.2906 29.0827 26.1641 29.0284C25.9109 28.9223 25.8231 28.8814 25.6496 28.8079C24.4774 28.2973 23.3924 27.6064 22.4339 26.7601C22.1767 26.5355 21.9378 26.2905 21.6928 26.0537C20.8896 25.2844 20.1896 24.4142 19.6103 23.4649L19.4899 23.2709C19.4046 23.1398 19.3348 22.9994 19.2816 22.8524C19.204 22.5523 19.4061 22.3113 19.4061 22.3113C19.4061 22.3113 19.9023 21.7683 20.133 21.4743C20.3576 21.1884 20.5474 20.9108 20.6699 20.7127C20.9109 20.3248 20.9864 19.9267 20.8598 19.6184C20.2881 18.2219 19.6974 16.8329 19.0876 15.4513C18.9672 15.1778 18.6099 14.9818 18.2853 14.943C18.175 14.9293 18.0648 14.9185 17.9545 14.9103C17.6804 14.8946 17.4055 14.8973 17.1317 14.9185L17.5441 14.9042Z" fill="#F8F8F8"/>
                            </svg>
                        </a>
                    )}
                    {
                    settings?.x_url && (
                        <a href={settings?.x_url} target="_blank">
                        <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M36.2415 6.125H42.5033L28.8242 21.6927L44.9166 42.875H32.3154L22.448 30.0268L11.1556 42.875H4.88767L19.5203 26.2252L4.08325 6.125H17.0029L25.925 17.8687L36.2415 6.125ZM34.0447 39.1428H37.5155L15.1164 9.66117H11.3924L34.0447 39.1428Z" fill="#F8F8F8"/>
                        </svg>
                    </a>
                    )}
                    {
                    settings?.instagram_url && (
                        <a href={settings?.instagram_url} target="_blank">
                        <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M24.5001 18.1214C20.9878 18.1214 18.1215 20.9877 18.1215 24.5C18.1215 28.0123 20.9878 30.8786 24.5001 30.8786C28.0124 30.8786 30.8787 28.0123 30.8787 24.5C30.8787 20.9877 28.0124 18.1214 24.5001 18.1214ZM43.6312 24.5C43.6312 21.8586 43.6551 19.2411 43.5067 16.6045C43.3584 13.542 42.6598 10.824 40.4203 8.58457C38.1761 6.34033 35.4629 5.64648 32.4004 5.49814C29.759 5.3498 27.1415 5.37373 24.5049 5.37373C21.8635 5.37373 19.246 5.3498 16.6094 5.49814C13.5469 5.64648 10.8289 6.34512 8.58946 8.58457C6.34522 10.8288 5.65137 13.542 5.50303 16.6045C5.35469 19.2459 5.37862 21.8634 5.37862 24.5C5.37862 27.1366 5.35469 29.7589 5.50303 32.3955C5.65137 35.458 6.35001 38.176 8.58946 40.4154C10.8337 42.6597 13.5469 43.3535 16.6094 43.5019C19.2508 43.6502 21.8683 43.6263 24.5049 43.6263C27.1463 43.6263 29.7638 43.6502 32.4004 43.5019C35.4629 43.3535 38.1809 42.6549 40.4203 40.4154C42.6646 38.1712 43.3584 35.458 43.5067 32.3955C43.6599 29.7589 43.6312 27.1414 43.6312 24.5ZM24.5001 34.3144C19.069 34.3144 14.6857 29.9312 14.6857 24.5C14.6857 19.0688 19.069 14.6856 24.5001 14.6856C29.9313 14.6856 34.3145 19.0688 34.3145 24.5C34.3145 29.9312 29.9313 34.3144 24.5001 34.3144ZM34.7164 16.5758C33.4483 16.5758 32.4243 15.5518 32.4243 14.2837C32.4243 13.0156 33.4483 11.9916 34.7164 11.9916C35.9845 11.9916 37.0085 13.0156 37.0085 14.2837C37.0089 14.5848 36.9499 14.883 36.8348 15.1613C36.7197 15.4395 36.5509 15.6924 36.338 15.9053C36.1251 16.1182 35.8723 16.287 35.594 16.4021C35.3157 16.5171 35.0175 16.5762 34.7164 16.5758Z" fill="#F8F8F8"/>
                        </svg>
                    </a>
                    )}
                    {
                    settings?.tiktok_url && (
                        <a href={settings?.tiktok_url} target="_blank">
                        <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M33.8917 11.8825C32.4961 10.2892 31.727 8.24309 31.7276 6.125H25.4188V31.4417C25.3702 32.8117 24.7918 34.1094 23.8054 35.0614C22.8191 36.0135 21.5018 36.5456 20.1309 36.5458C17.2317 36.5458 14.8226 34.1775 14.8226 31.2375C14.8226 27.7258 18.2117 25.0921 21.703 26.1742V19.7225C14.6592 18.7833 8.49341 24.255 8.49341 31.2375C8.49341 38.0363 14.1284 42.875 20.1105 42.875C26.5213 42.875 31.7276 37.6688 31.7276 31.2375V18.3954C34.2858 20.2326 37.3572 21.2183 40.5067 21.2129V14.9042C40.5067 14.9042 36.6684 15.0879 33.8917 11.8825Z" fill="#F8F8F8"/>
                        </svg>
                    </a>
                    )}
                    {
                        settings?.linkedin_url && (
                            <motion.a variants={item} href={settings.linkedin_url} target="blanck">
                                <img src={linkedin_url} alt="" />
                            </motion.a>
                        )
                    }
                </div>
                </div>
                <button onClick={() => {
                    dispatch(setShowNav());
                }}>X</button>
            </nav>
            <motion.div
                variants={container}
                initial="hidden"
                animate="visible"                        
                className="social">
                {
                    settings?.x_url && (
                        <motion.a variants={item} href={settings.x_url} target="blanck">
                            <img src={x} alt="" />
                        </motion.a>
                    )
                }
                {
                    settings?.tiktok_url && (
                        <motion.a variants={item} href={settings.tiktok_url} target="blanck">
                            <img src={tiktok} alt="" />
                        </motion.a>
                    )
                }
                {
                    settings?.instagram_url && (
                        <motion.a variants={item} href={settings.instagram_url} target="blanck">
                            <img src={instagram} alt="" />
                        </motion.a>
                    )
                }
                {
                    settings?.linkedin_url && (
                        <motion.a variants={item} href={settings.linkedin_url} target="blanck">
                            <img src={linkedin_url} alt="" />
                        </motion.a>
                    )
                }
            </motion.div>
            <motion.div
                variants={container}
                initial="hidden"
                animate="visible">

            {
                settings?.whatsapp_url && (
                    <motion.a variants={item2} href={settings.whatsapp_url} target="blanck" className="whatsapp">
                        <img src={whatsapp} alt="" />
                    </motion.a>
                )
            }
            </motion.div>
        </header>
    )
}

export default Header;